import { render, staticRenderFns } from "./FormularioListaPrecio.vue?vue&type=template&id=545669f2"
import script from "./FormularioListaPrecio.vue?vue&type=script&lang=js"
export * from "./FormularioListaPrecio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports